export default __webpack_public_path__ + "static/media/calathea.90b62d5c.gif";